export default __webpack_public_path__ + "static/media/payment-gateway.d6f83983.jpg";